<template>
  <div class=text_input_box>
    <div class="icon">
      <el-icon>
        <ChatLineRound />
      </el-icon>
    </div>
    <div class="input_box">
      <div class="tag_box">
        <el-space wrap>
          <el-tag class='pointer' type="primary" @click="addTag('#学生编码#')">学生编码</el-tag>
          <el-tag class='pointer' type="primary" @click="addTag('#学生姓名#')">学生姓名</el-tag>
          <el-tag class='pointer' type="primary" @click="addTag('#沟通称呼语#')">沟通称呼语</el-tag>
        </el-space>
      </div>
      <div class="editable_div" ref="editableDiv" contenteditable="true" @keydown="keydown" @input="contentChange" @click="editableDivClick" @paste="paste"></div>
      <div class="absolute_tip">
        {{showContentLength}}/500
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
const props = defineProps({
  data: {
    type: Object,
    required:true
  }
})
const editableDiv = ref();
const showContent = ref('');
const showContentLength = ref(0)
onMounted(()=>{
  transformSendContentToShowContent();
  editableDiv.value.innerHTML = showContent.value
  showContentLength.value = editableDiv.value.innerText.length
})

const transformSendContentToShowContent = ()=>{
  showContent.value = props.data.sendContent
  .replace(/#学生编码#/g,'<span class="qqq" contenteditable="false"><span class="input_tag" contenteditable="false">#学生编码#</span><span class="space" contenteditable="false">​</span></span>')
  .replace(/#学生姓名#/g,'<span class="qqq" contenteditable="false"><span class="input_tag" contenteditable="false">#学生姓名#</span><span class="space" contenteditable="false">​</span></span>')
  .replace(/#学生昵称#/g,'<span class="qqq" contenteditable="false"><span class="input_tag" contenteditable="false">#学生昵称#</span><span class="space" contenteditable="false">​</span></span>')
  .replace(/#沟通称呼语#/g,'<span class="qqq" contenteditable="false"><span class="input_tag" contenteditable="false">#沟通称呼语#</span><span class="space" contenteditable="false">​</span></span>')

}

let savedSelection = null;
// 保存当前光标位置
const saveSelection = () => {
    var selection = window.getSelection();
    // console.log('saveSelection',selection.rangeCount)
    // console.log('selection.getRangeAt(0).cloneRange()',selection.getRangeAt(0).cloneRange())
    if (selection.rangeCount > 0) {
        savedSelection = selection.getRangeAt(0).cloneRange();
    }
    // console.log('saveSelection',savedSelection)
}
// 恢复光标位置
const restoreSelection = () => {
    if (savedSelection) {
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(savedSelection);
    }
}
// 添加标签
const addTag = (txt) => {
  editableDiv.value.focus();
  restoreSelection();
  const qqq = document.createElement('span');
  qqq.className = 'qqq';
  qqq.setAttribute('contenteditable',false)
  qqq.innerHTML = `<span class='input_tag'>${txt}</span>`;
  const selection = window.getSelection();
  const range = selection.getRangeAt(0);
  range.insertNode(qqq);// 插入标签
  const empty = document.createTextNode(' ')
  range.insertNode(empty);// 插入标签
  range.insertNode(qqq);// 插入标签
  range.setStartAfter(empty);
  range.collapse(false);
  selection.removeAllRanges();
  selection.addRange(range);
  contentChange()
}
//处理按下回车键
const keydown = (e) => {
  if (e.key === 'Backspace') {
    // 删除整个标签
    const selection = window.getSelection();
    const anchorNode = selection.anchorNode;
    // console.log(anchorNode, anchorNode.parentElement)
    if (anchorNode.nodeType == 3 && anchorNode.classList?.contains('space')) {
      editableDiv.value.removeChild(anchorNode.parentNode)
      e.preventDefault()
    } else if (anchorNode.parentNode.classList?.contains('space')) {
      editableDiv.value.removeChild(anchorNode.parentNode.parentNode)
      e.preventDefault()
    }
  }else{
    if(editableDiv.value.innerText.length >= 500){
      e.preventDefault()
    }
  }
}
const paste = (e)=>{
  e.preventDefault(); // 阻止默认粘贴行为

    var text = (e.originalEvent || e).clipboardData.getData('text/plain'); // 获取纯文本

    // 在光标位置插入纯文本
    document.execCommand('inserttext', false, text);
}

const editableDivClick = ()=>{
  // console.log(editableDivClick)
  saveSelection();
}
const moveCursorToEnd = () => {
    var div = editableDiv.value;
    div.focus();

    // 创建一个新的Range对象并将其定位到div的末尾
    var range = document.createRange();
    range.selectNodeContents(div);
    range.collapse(false);

    // 获取Selection对象并将Range应用到Selection中
    var selection = window.getSelection();
    // selection.removeAllRanges();
    selection.addRange(range);
}
const contentChange = ()=>{
  // console.log(editableDiv.value.innerText)
  // props.data.showContent = editableDiv.value.innerHTML;
  if(editableDiv.value.innerText.length >= 500){
    // 看看有多少个标签 每个标签实际的长度与文本对应的长度相差80
    let num = 0;
    let str = editableDiv.value.innerHTML || '';
    str.replace(/#(.+?)#/g,()=>{num++})
    const l = 500 + num * 80;
    editableDiv.value.innerHTML = editableDiv.value.innerHTML.slice(0,l); // 这一行处理之后应该吧光标放到最后
    moveCursorToEnd()
  }
  props.data.sendContent = editableDiv.value.innerText.toString();
  showContentLength.value = editableDiv.value.innerText.toString().length;
  saveSelection()
}




</script>

<style lang="less" scoped>
.text_input_box {
  display: flex;
  align-items: center;

  .icon {
    width: 50px;
    text-align: center;
  }

  .input_box {
    position: relative;
    width: 600px;
    border: 1px solid #ccc;
    .tag_box{
      padding:5px 10px 5px 10px;
      border-bottom: 1px solid #ccc;
    }
    .editable_div {
      margin-top: 10px;
      height: 100px;
      outline: none;
      border: none;
      white-space: pre-wrap;
      padding:2px 10px 10px 10px;
      word-break: break-all;
      overflow-wrap: anywhere;
      overflow-y: scroll;
    }
    .absolute_tip{
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 12px;
      background-color: #fff;
      z-index: 100;
    }
  }
}
</style>